import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {
  Form, FormHeader,
  FormBack, FormFooter, FormNext,
  FormProgress,
  GelContentContainer,
  GelContentRow, GelContentColumn, Video,
  RadiosCustomElement,
  ResultCard, ALNIntroduction
} from "cw-styleguide-react";
import {route} from "../routes";
import Helmet from 'react-helmet';

class StepView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answersSelected: false,
    };
  }




  countAnswersAndCalculateResult() {
    let count = {
      [this.props.question.result1]: 0,
      [this.props.question.result2]: 0
    };

    [
      'step' + (this.props.question.id + 1) + 'Question1',
      'step' + (this.props.question.id  + 1) + 'Question2',
      'step' + (this.props.question.id  + 1) + 'Question3'
    ].forEach((answer) => {
      if (this.props.answers[answer]) {
        count[this.props.answers[answer]]++;
      }
    });

    return count[this.props.question.result1] > count[this.props.question.result2] ? 'result1' : 'result2';
  }

  render() {
    const result = this.countAnswersAndCalculateResult();

    const personMap = {
      E: 'Eddie',
      I: 'Ian',
      S: 'Sam',
      N: 'Niki',
      T: 'Tom',
      F: 'Finn',
      J: 'Joy',
      P: 'Penny'
    };

    const character1Name = personMap[this.props.result1];
    const character2Name = personMap[this.props.result2];

    return (
      <Fragment>
          <Helmet>
            <title>{this.props.question.title} | {this.props.t('app.name')}</title>
          </Helmet>

        <GelContentContainer>
          <h1>{this.props.t('app.name')}</h1>
          <Form theme={['no-padding', 'no-background']}>
            <FormProgress steps={[
              {title: this.props.question.step1Title, to: route('whereDoYouGainYourEnergyFrom')},
              {title: this.props.question.step2Title, to: route('howDoYouTakeInInformation')},
              {title: this.props.question.step3Title, to: route('howDoYouDecideThings')},
              {title: this.props.question.step4Title, to: route('whatIsYourAttitudeToLife')},
              {title: this.props.t('misc.results'), to: route('whatYourAnswersSayAboutYou')}
            ]}/>
          </Form>
          <h2>{this.props.question.subtitle}</h2>
          {/*<p className={'style style--introduction'}>{this.props.body[0]}</p>*/}
          <p className={'style style--introduction'}>{this.props.t('misc.stepIntro')}</p>
          <ALNIntroduction characters={[
            {name: character1Name, image: {alt: character1Name, source: this.props.question.image1}},
            {name: character2Name, image: {alt: character2Name, source: this.props.question.image2}}
          ]}/>
          <p>{this.props.question.body[1]}</p>
          <p>{this.props.question.body[2]}</p>
          <Form theme={['no-padding', 'no-background']}>
            <FormHeader>
              <FormBack url={this.props.back} theme={['secondary']}/>
            </FormHeader>
          </Form>
          {[1, 2, 3].map((questionIndex, index) => {
            const questionId = 'step' + (this.props.question.id + 1) + 'Question' + questionIndex;
            const answer1Id = 'question' + questionIndex + 'Answer1';
            const answer2Id = 'question' + questionIndex + 'Answer2';
            const answer1Label = this.props.question[answer1Id];
            const answer2Label = this.props.question[answer2Id];
            const groupLabel = this.props.t('styleguide:choose') + ' ' + answer1Label + ' ' + this.props.t('styleguide:or') + ' ' + answer2Label;
            return (
              <Form key={index}>

                <RadiosCustomElement type={'b'} groupLabel={groupLabel} name={questionId} value={this.props.answers[questionId]}  defaultChecked={this.props.answers[questionId]}  onChange={this.props.handleChange} options={
                  [
                    {
                      id: answer1Id,
                      label: answer1Label,
                      value: this.props.question.result1,
                      image: {source: this.props.question.image1, alt: character1Name},


                    },
                    {
                      id: answer2Id,
                      label: answer2Label,
                      value: this.props.question.result2,
                      image: {source: this.props.question.image2, alt: character2Name},


                    }
                  ]
                }

                />
              </Form>
            );
          })}
          <GelContentRow>
            <GelContentColumn md={10} mdOffset={1} lg={8} lgOffset={2}>
              {this.props.checkAllAnswersHaveBeenSelected(this.props.question.id) ?
                <GelContentRow>
                  <ResultCard noLink={true} link={false} title={this.props.question[result + 'Title']} images={
                    [
                      {alt: this.props.question[result + 'Title'], source: this.props.question[result + 'Image1']},
                      {alt: this.props.question[result + 'Title'], source: this.props.question[result + 'Image2']}
                    ]
                  }>
                    {this.props.question[result + 'List'].map((item, index) => {
                      return (
                        <Fragment key={index}>
                          <span>{item}</span>
                          {index !== (this.props.question[result + 'List'].length - 1) &&
                          <br/>
                          }
                        </Fragment>
                      );
                    })}
                  </ResultCard>
                </GelContentRow>
                :
                <img src={this.props.resultDefaultImage} alt={this.props[result + 'Title']}/>
              }
            </GelContentColumn>
          </GelContentRow>
          <Form theme={['no-padding', 'no-background']}>
            <FormFooter>
              <FormBack url={this.props.back}/>
              <FormNext url={this.props.checkAllAnswersHaveBeenSelected(this.props.question.id) ? this.props.next : null}
                        disabled={!this.props.checkAllAnswersHaveBeenSelected(this.props.question.id)} onClick={() => {
                this.props.answers['step' + (this.props.question.id + 1) + 'Letter'] = this.props.question[result]
              }}/>
            </FormFooter>
          </Form>
        </GelContentContainer>
      </Fragment>
    );
  }
}


export default withTranslation('local')(StepView);
